export const footerData = {
  footer: {
    links: [
      {
        message: 'Company',
        id: 'company',
        links: [
          {
            message: 'About',
            href: 'https://www.bitcoin.com/about-us/',
          },
          {
            message: 'Advertise',
            href: 'https://www.bitcoin.com/advertise/',
          },
          {
            message: 'Careers',
            href: 'https://www.bitcoin.com/jobs/',
          },
          {
            message: 'Blog',
            href: 'https://blog.bitcoin.com/',
          },
          {
            message: 'Contact',
            href: 'https://www.bitcoin.com/contact-us/',
          },
          {
            message: 'Partners',
            href: 'https://www.bitcoin.com/partners/',
          },
          {
            message: 'Support',
            href: 'https://support.bitcoin.com/en/',
          },
          {
            message: 'Legal',
            href: 'https://www.bitcoin.com/legal/user-agreement/',
          },
          {
            message: 'Sitemap',
            href: 'https://www.bitcoin.com/sitemap/',
          },
          {
            message: 'My Privacy Choices',
            href: 'https://www.bitcoin.com/legal/privacy-policy/',
          },
        ],
      },
      {
        message: 'Get Crypto',
        id: 'get',
        links: [
          {
            message: 'Buy Verse',
            href: 'https://buy.bitcoin.com/verse/',
          },
          {
            message: 'Buy Bitcoin',
            href: 'https://buy.bitcoin.com/btc/',
          },
          {
            message: 'Buy Ethereum',
            href: 'https://buy.bitcoin.com/eth/',
          },
          {
            message: 'Buy Bitcoin Cash',
            href: 'https://buy.bitcoin.com/bch/',
          },
          {
            message: 'Buy USDT',
            href: 'https://buy.bitcoin.com/',
          },
          {
            message: 'Buy USDC',
            href: 'https://buy.bitcoin.com/',
          },
          {
            message: 'Buy Avalanche',
            href: 'https://buy.bitcoin.com/avax/',
          },
          {
            message: 'Buy Polygon',
            href: 'https://buy.bitcoin.com/matic/',
          },
          {
            message: 'Bitcoin ATM',
            href: 'https://bitcoin.com/bitcoin-atm/',
          },
          {
            message: 'Crypto Faucets',
            href: 'https://www.bitcoin.com/faucets/',
          },
          {
            message: 'Crypto Tax',
            href: 'https://www.bitcoin.com/tax/',
          },
        ],
      },
      {
        message: 'Products & Services',
        id: 'products',
        links: [
          {
            message: 'News',
            href: 'https://news.bitcoin.com/',
          },
          {
            message: 'Learning Center',
            href: 'https://www.bitcoin.com/get-started/',
          },
          {
            message: 'Wallet',
            href: 'https://wallet.bitcoin.com/',
          },
          {
            message: 'Verse DEX',
            href: 'https://verse.bitcoin.com/',
          },
          {
            message: 'List in Wallet & Markets',
            href: 'https://forms.gle/bpcXQHKnmutvUDp68/',
          },
          {
            message: 'Bitcoin Cash Register',
            href: 'https://www.bitcoin.com/bitcoin-cash-register/',
          },
        ],
      },
      {
        message: 'Spend Crypto',
        id: 'spend',
        links: [
          {
            message: 'V-Card',
            href: 'https://verse.bitcoin.com/card/',
          },
          {
            message: 'Bitcoin Directory',
            href: 'https://www.bitcoin.com/directory/',
          },
          {
            message: 'Swap Bitcoin',
            href: 'https://www.bitcoin.com/swaps/',
          },
          {
            message: 'Sell Bitcoin',
            href: 'https://sell.bitcoin.com/',
          },
          {
            message: 'Crypto Merchants',
            href: 'https://www.bitcoin.com/find-crypto-merchants/',
          },
          {
            message: 'Bitcoin Map',
            href: 'https://map.bitcoin.com/',
          },
          {
            message: 'Bitcoin ATM',
            href: 'https://bitcoin.com/bitcoin-atm/',
          },
          {
            message: 'Bitcoin Teller Machine',
            href: 'https://www.bitcoin.com/bitcoin-teller-machine/',
          },
          {
            message: 'Bitcoin ETF',
            href: 'https://www.bitcoin.com/bitcoin-etf/',
          },
          {
            message: 'Ethereum ETF',
            href: 'https://www.bitcoin.com/ethereum-etf/',
          },
        ],
      },
      {
        message: 'Crypto Games',
        id: 'cgames',
        links: [
          {
            message: 'Games',
            href: 'https://games.bitcoin.com/',
          },
          {
            message: 'Casino',
            href: 'https://srt.bitcoin.com/casino-bcom',
          },
          {
            message: 'Bitcoin Slots',
            href: 'https://www.bitcoin.com/gambling/casino/slots/',
          },
          {
            message: 'Bitcoin Roulette',
            href: 'https://www.bitcoin.com/gambling/casino/roulette/',
          },
          {
            message: 'Bitcoin Blackjack',
            href: 'https://www.bitcoin.com/gambling/casino/blackjack/',
          },
          {
            message: 'Bitcoin Dice',
            href: 'https://www.bitcoin.com/gambling/casino/dice/',
          },
          {
            message: 'Bitcoin Gambling',
            href: 'https://www.bitcoin.com/gambling/',
          },
          {
            message: 'Bitcoin Poker',
            href: 'https://www.bitcoin.com/gambling/casino/poker/',
          },
          {
            message: 'Bitcoin Live Casino',
            href: 'https://www.bitcoin.com/gambling/casino/live-dealer/',
          },
          {
            message: 'Bitcoin Casino Bonus',
            href: 'https://www.bitcoin.com/gambling/casino/bonus/',
          },
          {
            message: 'Bitcoin Casino Free Spins',
            href: 'https://www.bitcoin.com/gambling/casino/free-spins/',
          },
          {
            message: 'Bitcoin Casino',
            href: 'https://www.bitcoin.com/bitcoin-casino/',
          },
        ],
      },
      {
        message: 'Bitcoin Data',
        id: 'data',
        links: [
          {
            message: 'Block Explorer',
            href: 'https://explorer.bitcoin.com/',
          },
          {
            message: 'Markets',
            href: 'https://markets.bitcoin.com/',
          },
          {
            message: 'Tools',
            href: 'https://www.bitcoin.com/tools/',
          },
        ],
      },
      {
        message: 'Educate',
        id: 'educate',
        links: [
          {
            message: 'Bitcoin Whitepaper',
            href: 'https://www.bitcoin.com/bitcoin.pdf',
          },
          {
            message: 'Learning Center',
            href: 'https://www.bitcoin.com/get-started/',
          },
          {
            message: "Satoshi's Archive",
            href: 'https://www.bitcoin.com/satoshi-archive/',
          },
          {
            message: 'Newsletters',
            href: 'https://www.bitcoin.com/newsletters/',
          },
        ],
      },
      {
        message: 'Exchanges',
        id: 'exchanges',
        links: [
          {
            message: 'Centralized',
            href: 'https://www.bitcoin.com/exchanges/centralized/',
          },
          {
            message: 'Decentralized',
            href: 'https://www.bitcoin.com/exchanges/decentralized/',
          },
          {
            message: 'For Beginners',
            href: 'https://www.bitcoin.com/exchanges/for-beginners/',
          },
          {
            message: 'Lowest fees',
            href: 'https://www.bitcoin.com/exchanges/lowest-fees/',
          },
          {
            message: 'P2P crypto exchange',
            href: 'https://www.bitcoin.com/exchanges/p2p-crypto-exchanges/',
          },
          {
            message: 'Swap platforms',
            href: 'https://www.bitcoin.com/exchanges/swap-platforms/',
          },
          {
            message: 'USA',
            href: 'https://www.bitcoin.com/exchanges/usa/',
          },
          {
            message: 'Asia',
            href: 'https://www.bitcoin.com/exchanges/asia/',
          },
          {
            message: 'Europe',
            href: 'https://www.bitcoin.com/exchanges/europe/',
          },
          {
            message: 'Ethereum exchange',
            href: 'https://www.bitcoin.com/ethereum-exchange/',
          },
          {
            message: 'Dogecoin',
            href: 'https://www.bitcoin.com/exchanges/dogecoin/',
          },
          {
            message: 'Solana',
            href: 'https://www.bitcoin.com/exchanges/solana/',
          },
        ],
      },
      {
        message: 'Bitcoin Games',
        id: 'bitcoin-games',
        links: [
          {
            message: 'Betting',
            href: 'https://www.bitcoin.com/gambling/betting/',
          },
          {
            message: 'Sportbook',
            href: 'https://www.bitcoin.com/gambling/betting/sportsbook/',
          },
          {
            message: 'Baseball',
            href: 'https://www.bitcoin.com/gambling/betting/baseball/',
          },
          {
            message: 'Basketball',
            href: 'https://www.bitcoin.com/gambling/betting/basketball/',
          },
          {
            message: 'Boxing',
            href: 'https://www.bitcoin.com/gambling/betting/boxing/',
          },
          {
            message: 'Cricket',
            href: 'https://www.bitcoin.com/gambling/betting/cricket/',
          },
          {
            message: 'Football',
            href: 'https://www.bitcoin.com/gambling/betting/football/',
          },
          {
            message: 'F1',
            href: 'https://www.bitcoin.com/gambling/betting/formula-1/',
          },
          {
            message: 'MMA',
            href: 'https://www.bitcoin.com/gambling/betting/mma/',
          },
        ],
      },
      {
        message: 'Follow',
        id: 'follow',
        links: [
          {
            message: 'Telegram',
            href: 'https://t.me/GetVerse/1/',
          },
          {
            message: 'Telegram (News)',
            href: 'https://t.me/www_Bitcoin_com',
          },
          {
            message: 'YouTube',
            href: 'https://www.youtube.com/channel/UCetxkZolEBHX47BqtZktbkg/',
          },
          {
            message: 'Instagram',
            href: 'https://www.instagram.com/bitcoin.com_official/',
          },
          {
            message: 'X',
            href: 'https://twitter.com/bitcoincom/',
          },
          {
            message: 'X (News)',
            href: 'https://x.com/BTCTN',
          },
          {
            message: 'Facebook',
            href: 'https://www.facebook.com/buy.bitcoin.news/',
          },
          {
            message: 'LinkedIn',
            href: 'https://www.linkedin.com/company/bitcoin.com/',
          },
          {
            message: 'TikTok',
            href: 'https://www.tiktok.com/@bitcoin.com_news/',
          },
          {
            message: 'Discord',
            href: 'https://discord.gg/qfEUDMP79w/',
          },
        ],
      },
    ],
    legal: {
      copyright: [
        '© {year} Saint Bitts LLC',
        'Bitcoin.com',
        'All rights reserved.',
        'support@bitcoin.com',
      ],
    },
    logo: {
      src: '/images/uploads/Bitcoin-logo.png',
      alt: 'Bitcoin.com Logo',
    },
    socialIcons: {
      telegram: {
        icon: 'telegram-icon.svg',
        href: 'https://t.me/GetVerse/1/',
      },
      youtube: {
        icon: 'youtube-icon.svg',
        href: 'https://www.youtube.com/channel/UCetxkZolEBHX47BqtZktbkg/',
      },
      instagram: {
        icon: 'instagram-icon.svg',
        href: 'https://www.instagram.com/bitcoin.com_official/',
      },
      twitter: {
        icon: 'twitter-icon.svg',
        href: 'https://twitter.com/bitcoincom/',
      },
      facebook: {
        icon: 'facebook-icon.svg',
        href: 'https://www.facebook.com/buy.bitcoin.news/',
      },
      linkedin: {
        icon: 'linkedin-icon.svg',
        href: 'https://www.linkedin.com/company/bitcoin.com/',
      },
      tiktok: {
        icon: 'tiktok-icon.svg',
        href: 'https://www.tiktok.com/@bitcoin.com_news/',
      },
      discord: {
        icon: 'discord-icon.svg',
        href: 'https://discord.gg/qfEUDMP79w/',
      },
    },
    appstore: {
      src: '/images/uploads/footer-app-store.svg',
      alt: 'Appstore logo',
      link: 'https://apps.apple.com/us/app/bitcoin-com-wallet-buy-sell/id1252903728?ls=1',
    },
    playstore: {
      src: '/images/uploads/footer-google-play.svg',
      alt: 'Playstore logo',
      link: 'https://play.google.com/store/apps/details?id=com.bitcoin.mwallet&pli=1',
    },
    copyright: '© 2025 Saint Bitts LLC Bitcoin.com. All rights reserved',
  },
};
